import { jsx as a } from "react/jsx-runtime";
import u from "@mui/material/styles/ThemeProvider";
import c from "@mui/material/styles/createTheme";
import { useMemo as r, Fragment as l } from "react";
import P from "./components.js";
import { PaletteLight as y, PaletteDark as k } from "./palette.js";
import x from "./shadows.js";
import { transitionsNone as d, transitionsNormal as v } from "./transitions.js";
import N from "./typography.js";
const z = {
  light: "light",
  dark: "dark"
}, A = ({
  disableTransitions: m,
  paletteMode: t = "light",
  customTheme: n,
  disableTheme: f,
  children: i
}) => {
  const o = r(() => t === "light" ? y : k, [t]), e = r(() => N(o), [o]), s = r(() => P(e, t), [e, t]), p = r(() => m ? d : v, [m]), g = r(() => c(
    {
      components: s,
      palette: o,
      shadows: x,
      spacing: (h) => `${10 * h}px`,
      // spacing in multiples of 10px
      transitions: p,
      typography: e
    },
    n || {}
  ), [s, o, p, e, n]);
  return f ? /* @__PURE__ */ a(l, { children: i }) : /* @__PURE__ */ a(u, { theme: g, children: i });
};
export {
  z as PaletteModes,
  A as default
};
//# sourceMappingURL=provider.js.map
